import React from 'react';
import { 
  createBrowserRouter, 
  RouterProvider, 
  Navigate 
} from 'react-router-dom';
import { CssBaseline, ThemeProvider } from '@mui/material';
import minimalTheme from './themes/minimalTheme';
import LoginPage from './pages/LoginPage';
import DashboardPage from './pages/DashboardPage';
import UsersPage from './pages/UsersPage';
import ContactsPage from './pages/ContactsPage';
import DistributorsPage from './pages/DistributorsPage';
import SubscriptionsPage from './pages/SubscriptionsPage';
import SettingsPage from './pages/SettingsPage';
import DevicesPage from './pages/DevicesPage';
import { AuthProvider, useAuth } from './contexts';
import './App.css';

const ProtectedRoute = ({ children }) => {
  const { isAuthenticated, loading } = useAuth();

  if (loading) {
    return (
      <div style={{ 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center', 
        minHeight: '100vh',
        backgroundColor: '#ffffff'
      }}>
        <div>Cargando...</div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  return children;
};

const router = createBrowserRouter([
  {
    path: "/login",
    element: <LoginPage />,
  },
  {
    path: "/",
    element: <ProtectedRoute><DashboardPage /></ProtectedRoute>,
  },
  {
    path: "/dashboard",
    element: <ProtectedRoute><DashboardPage /></ProtectedRoute>,
  },
  {
    path: "/users",
    element: <ProtectedRoute><UsersPage /></ProtectedRoute>,
  },
  {
    path: "/contacts",
    element: <ProtectedRoute><ContactsPage /></ProtectedRoute>,
  },
  {
    path: "/distributors",
    element: <ProtectedRoute><DistributorsPage /></ProtectedRoute>,
  },
  {
    path: "/subscriptions",
    element: <ProtectedRoute><SubscriptionsPage /></ProtectedRoute>,
  },
  {
    path: "/devices",
    element: <ProtectedRoute><DevicesPage /></ProtectedRoute>,
  },
  {
    path: "/settings",
    element: <ProtectedRoute><SettingsPage /></ProtectedRoute>,
  },
  {
    path: "*",
    element: <Navigate to="/" replace />,
  }
], {
  future: {
    // Opt-in a transitions DOM API
    v7_startTransition: true,
    // Opt-in a splat routing
    v7_relativeSplatPath: true,
  },
});

function App() {
  return (
    <ThemeProvider theme={minimalTheme}>
      <CssBaseline />
      <AuthProvider>
        <RouterProvider router={router} />
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App; 